import React from "react";

const EwalletHoldings = () => {
  return <div>EwalletHoldings</div>;
};

export default EwalletHoldings;
